export default __webpack_public_path__ + "static/media/quotation-marks.a8b7b381.svg";